import { motion } from 'framer-motion'

import { ViewBody, ViewBodyOverlay, ViewWrapper } from './View.styles'

interface ViewProps {
  children: React.ReactNode
  cover?: boolean
  collapsibleComponent?: boolean
  hasFooter?: boolean
  showOverlay?: boolean
  onOverlayClick?: () => void
}

const View = ({ children, cover, collapsibleComponent, showOverlay, onOverlayClick }: ViewProps) => {
  return (
    <ViewWrapper as={motion.div} initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} hasCollapse={collapsibleComponent}>
      <ViewBody cover={cover}>
        {children}
        <ViewBodyOverlay onClick={onOverlayClick} show={showOverlay} />
      </ViewBody>
    </ViewWrapper>
  )
}

export default View
